var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "arrow-previous",
  "use": "arrow-previous-usage",
  "viewBox": "0 0 15 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 28\" id=\"arrow-previous\"><path d=\"m13.265.322 1.47 1.356L3.36 14l11.375 12.322-1.47 1.356L.64 14z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol